import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { IUser } from "interfaces";

export const UserList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<IUser>({
    initialSorter: [
      {
        field: "user_id",
        order: "desc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="user_id">
        <Table.Column
          dataIndex="user_id"
          key="user_id"
          title="ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("user_id", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="email"
          key="email"
          title={t("user.fields.email")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title={t("parameter.fields.created_at")}
          render={(value) => <DateField value={value} format="LLL" />}
        />
        <Table.Column<IUser>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.user_id} />
              <ShowButton hideText size="small" recordItemId={record.user_id} />
              <DeleteButton hideText size="small" recordItemId={record.user_id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
